import React from 'react';
import { X } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ArticleModal = ({ article, onClose, onRead, onRemindLater }) => {
  const { token } = useAuth();
  if (!article) return null;

  const handleMarkRead = async () => {
    try {
      await axios.post(
        `${API_URL}/articles/${article.id}/mark-read`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onRead();
      onClose();
    } catch (error) {
      console.error('Error marking article as read:', error);
      alert('Erreur lors de la mise à jour');
    }
  };

  const handleRemindLater = async () => {
    try {
      await axios.post(
        `${API_URL}/articles/${article.id}/remind-later`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onRemindLater();
      onClose();
    } catch (error) {
      console.error('Error marking article to remind later:', error);
      alert('Erreur lors de la mise à jour');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col border border-border">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h2 className="text-xl font-bold text-foreground flex-1 pr-4">
            {article.title}
          </h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Fermer"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="prose prose-sm dark:prose-invert max-w-none">
            <div className="text-foreground whitespace-pre-wrap">
              {article.content}
            </div>
          </div>

          {/* Section info if exists */}
          {article.section && (
            <div className="mt-4 pt-4 border-t border-border">
              <span className="inline-block px-3 py-1 text-xs font-medium text-muted-foreground bg-secondary rounded-full">
                {article.section}
              </span>
            </div>
          )}
        </div>

        {/* Footer with buttons */}
        <div className="flex flex-col sm:flex-row gap-3 p-4 border-t border-border bg-secondary/30">
          <Button
            onClick={handleRemindLater}
            variant="outline"
            className="flex-1 text-sm"
          >
            📌 Me le rappeler plus tard
          </Button>
          <Button
            onClick={handleMarkRead}
            className="flex-1 text-sm bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            ✓ Lu
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ArticleModal;
